<form class="wrapper" [formGroup]="formGroup">
	<ng-container *ngIf="entity">
		<h2 *ngIf="entity.id">{{ 'REACT_EDIT_PAGE' | translate }} </h2>
		<h2 *ngIf="!entity.id">{{ 'REACT_CREATE_PAGE' | translate }} </h2>

		<bb-form-element [control]="formGroup.get('label')" [label]="'NAME' | translate">
			<bb-text required formControlName="label"></bb-text>
		</bb-form-element>

		<bb-form-element [required]="true" [control]="formGroup.get('playoutname')" [label]="'PLAYOUT' | translate">
			<bb-entity-selector [required]="true" [disableClear]="true" [entityType]="'playout'" [(ngModel)]="entity.playoutname"
				(ngModelChange)="valueChanged('playoutname', $event)" [ngModelOptions]="{standalone: true}" name="playoutname"
				[filterSet]="[{
					filters: [{
						type: 'playout',
						field: 'status',
						operator: 'isNot',
						value: 'inactive'
					}]
				}]"
			></bb-entity-selector>
		</bb-form-element>

		<bb-form-element [control]="formGroup.controls.timelineversion" [label]="'INTERACTIVITY_VERSION' | translate">
			<bb-select [(ngModel)]="entity.timelineversion" name="timelineversion" [ngModelOptions]="{standalone: true}"
				(ngModelChange)="valueChanged('timelineversion', $event)">
				<option *ngFor="let option of [{ label: 'PUBLISHED', value: 'published'}, { label: 'DRAFT', value: 'draft'}]"
					[value]="option.value">
					{{ option.label | translate }}
				</option>
			</bb-select>
		</bb-form-element>

		<bb-form-element *ngIf="projectContextOptions" [control]="formGroup.get('context')" [label]="'CONTEXT' | translate">
			<bb-entity-selector [(ngModel)]="entity.context" [options]="projectContextOptions" name="context"
				[ngModelOptions]="{standalone: true}" (ngModelChange)="valueChanged('context', $event)"
				>
			</bb-entity-selector>
		</bb-form-element>

		<bb-form-element [control]="formGroup.get('notifications')" [label]="'EMAIL_NOTIFICATIONS' | translate"
			[helpMessage]="'HELP.REACT_NOTIFICATIONS' | translate">
			<bb-check [(ngModel)]="entity.notifications" name="notifications" [ngModelOptions]="{standalone: true}"
				(ngModelChange)="valueChanged('notifications', $event)">
			</bb-check>
		</bb-form-element>

		<bb-form-element [control]="formGroup.get('password')" [label]="'PASSWORD' | translate"
			[helpMessage]="'HELP.REACT_PASSWORD' | translate">
			<div *ngIf="entity.password_set" class="password-reset">
				<p>*********</p>
				<bb-button (click)="onResetPassword()" icon="eraser">{{ "RESET_PASSWORD" | translate}}</bb-button>
			</div>
			<bb-text *ngIf="!entity.password_set" formControlName="password"></bb-text>
		</bb-form-element>

		<bb-form-element [label]="'URL' | translate">
			<div *ngIf="entity.id" class="url-container">
				<textarea readonly class="url">{{ reactUrl }}</textarea>
				<bb-button icon="copy" (click)="onCopyUrl()">
					{{ 'COPY' | translate }}
				</bb-button>
			</div>
			<div *ngIf="!entity.id" class="save-first">
				<p>{{ 'REACT_SAVE_FIRST' | translate }}</p>
			</div>
		</bb-form-element>
	</ng-container>
</form>
<div class="actions" *ngIf="entity">
	<div>
		<button *ngIf="entity.id" class="button" (click)="delete()">
			<i class="fa fa-trash"></i> {{ 'DELETE' | translate }}
		</button>
	</div>
	<div>
		<button class="button cancel" (click)="onCancelClick()">
			<i class="fa fa-ban"></i> {{ 'CANCEL' | translate }}
		</button>
		<button class="button submit" (click)="saveQuickEdit()">
			<i class="fa fa-floppy-o"></i> {{ 'SAVE' || translate }}
		</button>
	</div>
</div>
